import { Controller } from "@hotwired/stimulus"
import { parseNumber, formatNumber } from "../lib/number_helper"

export default class extends Controller {
  static targets = [
    "amountInput",
    "totalAmount",
    "row",
    "connectedPriceInput",
    "weightedPricePerMwh",
    "headerConnectedAmount",
    "table",
    "accordeonIndicator",
  ]

  hideTable() {
    this.tableTarget.classList.toggle("hidden")
    this.accordeonIndicatorTargets.forEach((indicator) => {
      indicator.classList.toggle("hidden")
    })
  }

  updateHeader() {
    if (this.hasHeaderConnectedAmountTarget && this.hasTotalAmountTarget) {
      const total = this.totalAmount()

      this.headerConnectedAmountTarget.textContent = total
    }
  }

  updateAmount() {
    const total = this.totalAmount()

    this.totalAmountTarget.textContent = formatNumber(total, {
      minimumFractionDigits: 1,
    })

    this.updatePrice()
  }

  updatePrice() {
    const totalPrice = this.rowTargets.reduce((sum, row) => {
      const amount = parseNumber(
        row.querySelector(
          '[data-delivery-connection-table-target="amountInput"]',
        ).value,
      )
      const pricePerMwh = parseNumber(
        row.querySelector(
          '[data-delivery-connection-table-target="connectedPriceInput"]',
        ).value,
      )

      return sum + amount * pricePerMwh
    }, 0)

    const totalAmount = this.totalAmount()
    const pricePerMwh = totalAmount === 0 ? 0 : totalPrice / totalAmount
    const deliveryPriceInputTarget = document.getElementById(
      "delivery_price_per_mwh",
    )
    const deliveryConnectionTableCount = document.querySelectorAll(
      '[data-controller="delivery-connection-table"]',
    ).length

    this.weightedPricePerMwhTarget.textContent = pricePerMwh.toLocaleString(
      "de-CH",
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    )

    if (deliveryConnectionTableCount === 1) {
      // We use a very similar method in sales-contract-delivery-form_controller.js for multiple tables.
      if (
        !deliveryPriceInputTarget.value ||
        deliveryPriceInputTarget.dataset.manualAmount === "false"
      ) {
        deliveryPriceInputTarget.value = pricePerMwh.toFixed(2)
      }
    }
  }

  totalAmount() {
    return this.amountInputTargets.reduce(
      (sum, input) => sum + parseNumber(input.value),
      0,
    )
  }
}
